import { DeployEnv, getDeployArea, getDeployEnv } from "@ti/max";
import * as Sentry from "@sentry/browser";
import { printAppInfo } from "@/tiMax/utils/initConsole";
import * as Arms from "@/tiMax/utils/arms";
import DownloadStatusPolling from "@/utils/DownloadStatusPolling";
import packageInfo from "../package.json";

export async function getInitialState() {
  return {
    DownloadStatusPolling: new DownloadStatusPolling(),
  };
}

export const spiral = {
  microAppInitConfig: {
    excludeAssetFilter: (url: string) => {
      return ["maps.googleapis.com"].some((v) => url?.includes(v));
    },
    plugins: {
      global: [
        {
          escapeProperties: ["google"],
        },
      ],
    },
  },
};

printAppInfo();

const deployArea = getDeployArea();
const env = getDeployEnv();
const area = getDeployArea();

if (process.env.NODE_ENV !== "development" && [DeployEnv.TEST, DeployEnv.PROD].includes(env)) {
  Sentry.init({
    dsn: "https://4ab3ba5624b44476888fa6e972ebb37a@sentry.starcharge.com/98",
    release: packageInfo.version,
    environment: `${env}@${area}`,
    integrations: [
      Sentry.browserTracingIntegration(),
    ],
    tracesSampleRate: env === DeployEnv.PROD ? 0.1 : 0.5,
    ignoreErrors: [
      /.*\[request\].*/,
      /.*Unexpected token '<'.*/,
      /.*Network Error.*/,
      "Load failed",
      "[object Object]",
    ],
  });
}

const armsPid = {
  cn: "gmpgmsbi3k@a4f0864d77500f6",
  eu: "gmpgmsbi3k@58587fcff93613a",
  sg: "gmpgmsbi3k@d0ab58009694ff1",
  us: "gmpgmsbi3k@c34036bc1ea7f19",
}[deployArea];

Arms.init(armsPid);
